// export default axios
import qs from 'qs'
import _ from 'lodash'
import { get, isEmpty , identity } from 'lodash/fp'
const serverFormData = require('isomorphic-form-data')
import { transDataType } from '~/plugins/req/ContentType'

export default ({ req, res, store, $axios }) => {
  $axios.interceptors.request.use((config, request) => {
    // Get token from auth.js store
    let tokenKey = 'authUser/info/AccessToken'
    let tokenKeys = tokenKey.split('/').filter(x => x)
    let lastTokenKey = tokenKeys.pop()
    let token = _.get(store.getters, tokenKeys.concat(['token']), '')

    // Update token axios header
    if (!_.isEmpty(token)) {
      config.headers[(lastTokenKey.substring(0,1).toUpperCase() + lastTokenKey.substring(1)).replace(/([A-Z]|^ms)/g, "-$1").substring(1)] = token
    }

    // 数据提交方式
    config.transformRequest = [function (data, headers) {
      if (process.server
          && !['POST', 'PUT', 'PATCH'].includes(req.method)
          || typeof data !== 'object') {
        return process.server
          ? qs.stringify(data)
          : data
      }
      return transDataType(headers, data, process.server, config.method)
    }]
    return config
  })
}



// WEBPACK FOOTER //
// ./plugins/axios.js